import React from "react";
import styles from "../../styles/screens/PrasadGift/PGDarbar.module.css";
import RamDarbar from "../../assets/prasad_gift/ramImg.png"
import KrishnaDarbar from "../../assets/prasad_gift/krishnaImg.png"
const PGDarbar = ({ productId }) => {
  return (
    <div className={styles.ramDarbarContainer}>
      <div className={styles.backgroundFlower}></div>
      <div className={styles.content}>
        <h1 className={styles.title}>
          {productId === "ramdarbar" ? "Ram Darbar" : "Krishna Darbar"}
        </h1>
        {/* <div className={styles.titleUnderline}></div> */}

        <p className={styles.description}>
          {productId === "ramdarbar" ? (
            <>
              This elegant Golden Ram Darbar prayer box blends spirituality with
              style. Inside, a golden Charan Paduka with intricate designs and
              sparkling stones complements the vibrant deity image on the lid,
              forming a compact altar for daily worship.
            </>
          ) : (
            <>
              This Vrindavan Darbar prayer box beautifully blends devotion and
              artistry. It includes a golden Krishna Ji Charan Paduka adorned
              with intricate designs and stones, with a serene image of Lord
              Krishna on the lid, creating a portable shrine for daily worship.
            </>
          )}
        </p>

        <div className={styles.productDisplay}>
          <img
            src={productId === "ramdarbar" ? RamDarbar : KrishnaDarbar}
            alt={productId === "ramdarbar" ? "Ram Darbar Prayer Box" : "Krishna Darbar Prayer Box"}
            className={styles.productImage}
          />
        </div>
      </div>
    </div>
  );
};

export default PGDarbar;
